import useCreatePatient from "./useCreatePatient";

export { useCreatePatient };

const hooks = { useCreatePatient };

export default hooks;
